<script>
import {jumpProps, initValue} from './index.js'
import {clickEventHandler} from '../../../utils/share'

export default {
  name: 'jump',
  props: jumpProps,
  inject: ['popupParams'],
  computed: {
    // 没有跳转链接
    isJump () {
      const operationApiName = this.linkOperationApiName
      if (operationApiName && this.id) {
        const queryIds = [this.popupParams?.id, this.$route.query?.id].filter(v => v)
        if (queryIds.length) {
          return !queryIds.find(v => Number(v) === Number(this.id))
        }
        return true
      }
    }
  },
  methods: {
    /**
     * 跳转
     */
    jump () {
      if (!this.isJump) {
        return
      }
      const {query} = this.$route
      const linkObjectModel = {
        layoutApiName: this.layoutApiName,
        objectApiName: this.linkObjectApiName,
        tenantType: this.tenantType,
        operationApiName: this.linkOperationApiName
      }
      clickEventHandler({
        buttonItem: {
          buttonType: this.linkOperationApiName
        },
        linkObjectModel,
        query: {
          id: this.id,
          c: query.c
        },
        url: '/paas/detail',
        row: this.row
      })
    }
  },
  render (h) {
    const value = initValue(this.value)
    return (
      <div class={this.isJump ? 'jump' : ''} on-click={this.jump}>
        <read-text value={value} showTooltip={this.showTooltip}></read-text>
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
.jump {
  width: 100%;
  color: #3072f3;
  cursor: pointer;
}
</style>